import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import endpointsConfig from "endpoints.config";

interface SignalRTestRouteGuardProps {
  children: ReactNode;
}

const SignalRTestRouteGuard: FC<SignalRTestRouteGuardProps> = ({
  children,
}) => {
  const baseUrl = endpointsConfig.UserBaseUrl.toLowerCase();

  const isLocalEnvironment =
    baseUrl.includes("localhost") ||
    baseUrl.includes("-local.") ||
    baseUrl.includes("appservice-api-local");

  const isDevEnvironment =
    baseUrl.includes("-dev.") || baseUrl.includes("/dev");

  if (!isLocalEnvironment && !isDevEnvironment) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default SignalRTestRouteGuard;
